// A game's middlegame result: the stage grid (`stage-result.ts`) applied to
// the middlegame. Its start is the reader's standing at the middlegame's
// first move; its end the standing of the position taken into the ending, or
// — when the game finished in the middlegame — the game's outcome (won →
// winning, drawn → level, lost → lost):
//
//   start \ end    winning    level             lost
//   winning        ahead      blown advantage   blown advantage
//   level          ahead      level             behind
//   lost           comeback   comeback          behind
//
// Pure: the caller (api-insights' fact extractor) supplies the scores.
import type { MiddlegameResult, StageStanding } from '@chess/api-model';
import { stageCellOf, type StageCell } from './stage-result.ts';

const NAME: Record<StageCell, MiddlegameResult> = { up: 'ahead', comeback: 'comeback', even: 'level', blown: 'blown', down: 'behind' };

/** The middlegame result of a game whose middlegame started at `start` and ended at `end`. */
export function middlegameResultOf(start: StageStanding, end: StageStanding): MiddlegameResult {
  return NAME[stageCellOf(start, end)];
}
